/**
 * @generated SignedSource<<922e5ebfc0193b217016b4bb1d03c603>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatedBySubject_actor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SignedActorCompact_actor">;
  readonly " $fragmentType": "CreatedBySubject_actor";
};
export type CreatedBySubject_actor$key = {
  readonly " $data"?: CreatedBySubject_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatedBySubject_actor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatedBySubject_actor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignedActorCompact_actor"
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "8c0322992fccac79f20c34e931ce4dcd";

export default node;
